/**
 * Scrolls an element into view.
 * @param element - The element to scroll into view
 */
export function ScrollElementIntoView(element: HTMLElement | null): void {
    if (element === null) {
        console.error("element is null");
        return;
    }

    element.scrollIntoView();
}

/**
 * Copies a link from the element's data-link attribute to the clipboard.
 * @param event - The event object
 * @param element - The element containing the data-link attribute
 */
export function CopyLink(event: Event, element: HTMLElement): void {
    event.preventDefault();
    const link = element.getAttribute("data-link");
    if (link) {
        navigator.clipboard.writeText(link).catch((error: Error) => {
            console.error("Failed to copy link to clipboard:", error);
        });
    }
}

/**
 * Closes a details element by removing the "open" attribute.
 * @param detailsElement - The details element to close
 */
export function CloseDetails(detailsElement: HTMLElement): void {
    try {
        detailsElement.removeAttribute("open");
    } catch (error) {
        console.error("Unable to close details element: " + error);
    }
}

/**
 * Retrieves a DOM element by its ID.
 * @param elementId - The ID of the element to retrieve
 * @returns The element, or null if not found
 */
export function GetElement(elementId: string): HTMLElement | null {
    const element = document.getElementById(elementId);
    if (elementId === undefined || elementId === null) {
        console.warn("Unable to find element with id " + elementId);
        return null;
    }

    return element;
}